export const PDF = {
  TERMS_MERCHANT_ONBOARDING: 'terms_merchant_onboarding',
  CERTIFICATE_TO_TRANSPORT_INVESTIGATION:
    'certificate_to_transport_investigation',
}

export const LEGAL = {
  GET_VISITOR_ID: 'get_visitor_id',
  REFER_FRIEND: 'refer_friend_terms_conditions',
}
